<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="listData"
      :page.sync="page"
      :search.sync="searchForm"
      v-model="tableForm"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <!-- 表格插槽 -->
      <template slot-scope="{ row }" slot="subModuleId">
        {{ row.subModuleName }}
      </template>
      <template slot-scope="{ row }" slot="userId">
        {{ row.userName }}
      </template>
      <template slot-scope="{ row }" slot="deptIds">
        {{ row.deptNames }}
      </template>
      <!-- 自定义搜索 -->
      <template slot="userIdSearch">
        <el-input
          clearable
          show-word-limit
          maxlength="30"
          v-model="searchForm.userName"
          placeholder="负责人"
        ></el-input>
      </template>
      <template slot="deptIdsSearch">
        <el-input
          clearable
          show-word-limit
          maxlength="30"
          v-model="searchForm.deptNames"
          placeholder="部门"
        ></el-input>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  getList,
  add,
  update,
  remove,
  getSubModuleList,
  getDeptTreeByProjectId,
  getUserListByModuleType,
} from '@/api/v4ward/gateservice/ordersetting/setting/ordersettingapproverule';

export default {
  props: ['row'],
  data() {
    return {
      loading: true,
      listData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        dialogClickModal: false,
        refreshBtn: false,
        viewBtn: true,
        align: 'left',
        dialogWidth: '50%',
        labelWidth: 110,
        column: [
          {
            label: '工单子类型',
            prop: 'subModuleId',
            slot: true,
            type: 'select',
            search: true,
            searchLabelWidth: 100,
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            rules: [
              {
                required: false,
                message: '请选择工单子类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '负责人',
            prop: 'userId',
            slot: true,
            search: true,
            searchslot: true,
            span: 24,
            type: 'tree',
            dicData: [],
            props: {
              label: 'realNameAndPhone',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择负责人',
                trigger: 'change',
              },
            ],
          },
          {
            label: '部门',
            prop: 'deptIds',
            slot: true,
            search: true,
            searchslot: true,
            span: 24,
            type: 'tree',
            multiple: true,
            checkStrictly: true,
            dicData: [],
            props: {
              label: 'title',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择部门',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      tableForm: {}, // 表单数据
      searchForm: {}, // 搜索数据
      projectId: '', // 项目id
      moduleType: 0, // 工单类型
      settingId: '', // 工单设置id
      subModuleList: [], // 子类型列表
      deptList: [], // 部门列表
    };
  },
  watch: {
    'tableForm.subModuleId': function (val, old) {
      // console.log('approve-rule watch subModuleId:', val, old);
      if (val) {
        if (old) {
          // 只有修改值了才清空，从无到有不清空，否则刚打开弹窗时看不到值了
          this.tableForm.userId = '';
          this.findObject(this.option.column, 'userId').dicData = [];
        }
        this.getUserList(val);
      }
    },
  },
  created() {
    // console.log('approve-rule created row:', this.row);
    this.setAvueCrudHeight();
    this.initData();
  },
  methods: {
    setAvueCrudHeight() {
      this.option.height = this.bodyHeight - 379;
    },
    async initData() {
      let oldProjectId = this.projectId;
      this.projectId = this.row.projectId;
      this.moduleType = this.row.moduleType;
      this.settingId = this.row.id;
      // 清空旧数据
      this.subModuleList = [];
      this.findObject(this.option.column, 'subModuleId').dicData = [];
      this.findObject(this.option.column, 'userId').dicData = [];
      // 部门数据只跟项目关联，所以不用每次请求数据
      if (oldProjectId != this.projectId || this.deptList.length == 0) {
        this.deptList = [];
        this.findObject(this.option.column, 'deptIds').dicData = [];
        this.getDeptList();
      }
      await this.getSubModuleList();
      // 如果没有子类型，则直接获取父类型数据，有子类型则等选择子类型后再获取数据
      if (this.subModuleList.length == 0) {
        this.findObject(this.option.column, 'subModuleId').rules[0].required = false;
        this.getUserList();
      } else {
        this.findObject(this.option.column, 'subModuleId').rules[0].required = true;
      }
    },
    async getSubModuleList() {
      await getSubModuleList({
        projectId: this.projectId,
        moduleType: this.moduleType,
      }).then(({ data }) => {
        if (JSON.stringify(data) == '{}') { // 没有数据时后台返回的是{}
          data = [];
        }
        this.subModuleList = data || [];
        this.findObject(this.option.column, 'subModuleId').dicData = this.subModuleList;
      });
    },
    getDeptList() {
      getDeptTreeByProjectId({
        projectId: this.projectId,
      }).then(({ data }) => {
        if (JSON.stringify(data) == '{}') { // 没有数据时后台返回的是{}
          data = [];
        }
        this.deptList = data || [];
        this.findObject(this.option.column, 'deptIds').dicData = this.deptList;
      });
    },
    getUserList(subModuleId) {
      getUserListByModuleType({
        projectId: this.projectId,
        moduleType: this.moduleType,
        subModuleId,
      }).then(({ data }) => {
        if (JSON.stringify(data.userList) == '{}') { // 没有数据时后台返回的是{}
          data.userList = [];
        }
        this.findObject(this.option.column, 'userId').dicData = data.userList || [];
      });
    },
    rowSave(row, done, loading) {
      // console.log('approve-rule rowSave tableForm:', this.tableForm);
      let params = {
        settingId: this.settingId,
        subModuleId: this.tableForm.subModuleId || '',
        userId: this.tableForm.userId,
        deptIds: this.tableForm.deptIds.join(','),
      };
      add(params).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      // console.log('approve-rule rowUpdate tableForm:', this.tableForm);
      let params = {
        settingId: this.settingId,
        projectId: this.projectId,
        ids: this.tableForm.ids,
        subModuleId: this.tableForm.subModuleId || '',
        userId: this.tableForm.userId,
        deptIds: this.tableForm.deptIds,
      };
      update(params).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      let params = {
        settingId: this.settingId,
        projectId: this.projectId,
        ids: row.ids,
      };
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove(params);
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    searchReset() {
      this.searchForm = {};
      this.page.currentPage = 1;
      this.onLoad();
    },
    searchChange(params, done) {
      this.searchForm = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(
        Object.assign(
          {
            settingId: this.settingId,
            current: page.currentPage,
            size: page.pageSize,
          },
          this.searchForm
        )
      )
        .then(({ data }) => {
          this.page.total = data.total;
          this.listData = data.records;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
::v-deep .el-table--small {
  height: 630px !important;
}
::v-deep .avue-crud__pagination {
  padding-bottom: 0 !important;
}
::v-deep .el-table .cell {
  line-height: 60px !important;
}
</style>
